import { MaterialModule } from '../material.module';
import { NgModule } from '@angular/core';
import { LandingComponent } from './landing.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    SharedModule
  ],
  declarations: [
    LandingComponent
  ]
})
export class LandingModule { }
